angular.module('storefrontApp')
    .controller('productController', [
        '$rootScope',
        '$scope',
        '$window',
        '$q',
        'dialogService',
        'catalogService',
        'cartService',
        'quoteRequestService',
        'listService',
        'googleAnalyticsService',
        'productListService',
        'rsSizingChartService',
        function (
            $rootScope,
            $scope,
            $window,
            $q,
            dialogService,
            catalogService,
            cartService,
            quoteRequestService,
            listService,
            googleAnalyticsService,
            productListService,
            rsSizingChartService,
        ) {
            // TODO: prevent add to cart not selected variation
            // display validator please select property
            // display price range

            let allVariations = [];
            let currentProduct = null;

            $scope.selectedVariation = {};
            $scope.allVariationPropsMap = {};
            $scope.productPrice = null;
            $scope.productPriceLoaded = false;
            $scope.addToWishlistDisabled = false;
            $scope.availableLists = null;
            $scope.listType = null;
            $scope.colorProps = [];
            $scope.productLoaded = false;
            $scope.currentImage = '';
            $scope.current = {
                color: null,
                size: null,
            };
            $scope.view = {
                showColor: true,
                showSize: true,
            };
            $scope.quantity = 1;

            $scope.disableAddToCart = function () {
                return !isVariationEnabled($scope.selectedVariation)
                    || ($scope.view.showColor && !$scope.current.color)
                    || ($scope.view.showSize && !$scope.current.size)
                    || (window.browseOnlyMode === true);
            };

            $scope.addProductToWishlist = function (product) {
                if (!$scope.customer.isRegisteredUser) {
                    $window.location = '/account/login?returnUrl=' + product.url;
                    return;
                }

                if (product) {
                    $scope.productLoaded = false;

                    listService.addLineItem(product.id, 'wishlist', 'wishlist')
                        .then(function ({ status }) {
                            if (status === 200) {
                                checkProductInWishlist();
                                googleAnalyticsService.addProductToWishlist(product);
                            }
                        });
                }
            };

            $scope.deleteProductFromWishlist = function () {
                if ($scope.wishedProduct) {
                    $scope.productLoaded = false;

                    listService.removeLineItem($scope.wishedProduct.id, 'wishlist', 'wishlist')
                        .then(function ({ status }) {
                            if (status === 200) {
                                $scope.wishedProduct = null;
                                $scope.isWished = false;
                                $scope.productLoaded = true;
                            }
                        });
                }
            };

            $scope.addProductToCart = function (product, quantity) {
                // Check if store is in BrowseOnly mode
                if (window.browseOnlyMode === true) {
                    alert('Store is currently in browse-only mode. Adding items to cart is not allowed.');
                    return;
                }

                const dialogData = toDialogDataModel(product, quantity);

                dialogService.showDialog(
                    dialogData,
                    'recentlyAddedCartItemDialogController',
                    'storefront.recently-added-cart-item-dialog.tpl',
                );

                cartService.addLineItem(product.id, quantity)
                    .then(function () {
                        $rootScope.$broadcast('cartItemsChanged');
                        googleAnalyticsService.addProductToCart(product, quantity);
                    });
            };

            $scope.addProductToCartById = function (productId, quantity, event) {
                event.preventDefault();

                // Check if store is in BrowseOnly mode
                if (window.browseOnlyMode === true) {
                    alert('Store is currently in browse-only mode. Adding items to cart is not allowed.');
                    return;
                }

                catalogService.getProduct([productId])
                    .then(function (response) {
                        if (response.data && response.data.length) {
                            const product = response.data[0];
                            $scope.addProductToCart(product, quantity);
                        }
                    });
            };

            $scope.addProductToActualQuoteRequest = function (product, quantity) {
                const dialogData = toDialogDataModel(product, quantity);

                dialogService.showDialog(
                    dialogData,
                    'recentlyAddedActualQuoteRequestItemDialogController',
                    'storefront.recently-added-actual-quote-request-item-dialog.tpl',
                );

                quoteRequestService.addProductToQuoteRequest(product.id, quantity)
                    .then(function () {
                        $rootScope.$broadcast('actualQuoteRequestItemsChanged');
                    });
            };

            $scope.initAvailableLists = function (lists) {
                $scope.listType = lists.default_list_type;
            };

            function toDialogDataModel(product, quantity) {
                return {
                    imageUrl: product.primaryImage ? product.primaryImage.url : null,
                    listPrice: product.price.listPrice,
                    id: product.id,
                    listPriceWithTax: product.price.listPriceWithTax,
                    name: product.name,
                    placedPrice: product.price.actualPrice,
                    placedPriceWithTax: product.price.actualPriceWithTax,
                    quantity,
                    updated: false,
                    showGoToCartButton: true,
                    variationProperties: product.variationProperties,
                };
            }

            function isVariationEnabled(variation) {
                return variation
                    && variation.isInStock === true
                    && variation.isActive === true
                    && variation.isBuyable === true;
            }

            function initialize() {
                const productIds = $window.products.map(({ id }) => id);

                if (!productIds.length) {
                    return;
                }

                catalogService.getProduct(productIds)
                    .then(function (response) {
                        currentProduct = response.data[0];

                        // Current product is also a variation (titular)
                        allVariations = [currentProduct].concat(currentProduct.variations || []);
                        return getFlatternDistinctPropertiesMap(allVariations);
                    })
                    .then(function (allVariationPropsMap) {
                        $scope.allVariationPropsMap = allVariationPropsMap;
                        $scope.selectedVariation = currentProduct.variations && currentProduct.variations.length > 0
                            ? currentProduct.variations[0]
                            : currentProduct;

                        checkProductInWishlist();

                        getImageUrlForVariationProp(allVariations, $scope.allVariationPropsMap.Color);

                        $scope.view.showSize = angular.isDefined($scope.allVariationPropsMap.Size);

                        if ($scope.view.showSize) {
                            $scope.allSizeProps = $scope.allVariationPropsMap.Size.map((item) => {
                                item.isEnabled = true;
                                return item;
                            });
                        }

                        $scope.view.showColor = angular.isDefined($scope.allVariationPropsMap.Color)
                            && $scope.allVariationPropsMap.Color.length > 0;

                        if ($scope.view.showColor) {
                            $scope.colorProps = $scope.allVariationPropsMap.Color.map((item) => {
                                item.isEnabled = true;
                                return item;
                            });
                        }

                        const urlVariationId = location.search.replace('?variation=', '');
                        const urlVariation = currentProduct.variations.find((x) => x.id === urlVariationId);

                        if (urlVariation) {
                            $scope.selectedVariation = urlVariation;

                            // Auto select product variation
                            const propertyMap = getVariationPropertyMap(
                                $scope.selectedVariation,
                                $scope.allVariationPropsMap.keys,
                            );

                            _.each(_.keys(propertyMap), function (x) {
                                $scope.selectProperty(propertyMap[x][0]);
                            });
                        } else {
                            const defaultColor = currentProduct.properties.find((x) => x.name === 'DefaultColor');

                            const colorProp = defaultColor && defaultColor.value
                                ? $scope.colorProps
                                    .find(({ value }) => value.toLowerCase() === defaultColor.value.toLowerCase())
                                : $scope.colorProps[0];

                            $scope.selectProperty(colorProp);
                        }

                        if (!$scope.view.showColor) {
                            $scope.currentImage = angular.extend($scope.selectedVariation.primaryImage.url, {});
                        }

                        const assocProductIds = _.map($window.assocProducts, function (e) {
                            return e.id;
                        });

                        productListService.getProductListData(assocProductIds)
                            .then(function (result) {
                                angular.extend($scope, result);
                            });

                        allVariations.forEach((variation) => {
                            checkAvailabilityForProperties(variation);
                        });

                        checkAvailabilityForProperties($scope.selectedVariation);

                        $scope.productLoaded = true;
                        googleAnalyticsService.viewItem($scope.selectedVariation);
                    });
            }

            function checkProductInWishlist() {
                if (!$scope.customer || !$scope.customer.isRegisteredUser) {
                    return;
                }

                $scope.productLoaded = false;

                listService.getWishlist('wishlist', 'wishlist')
                    .then(function (response) {
                        $scope.wishedProduct = _.find(
                            response.data.items,
                            (x) => x.product.titularItemId === $scope.selectedVariation.titularItemId,
                        );

                        if ($scope.wishedProduct) {
                            $scope.isWished = true;
                        }

                        $scope.productLoaded = true;
                    });
            }

            // add imgSrc field to Color varation property (pick it from variation.primaryImage that match to this color)
            function getImageUrlForVariationProp(variations, colorProps) {
                if (colorProps) {
                    colorProps.map((color) => {
                        if (!color.value) {
                            return color;
                        }

                        const single = variations.filter((variation) => variation.variationProperties
                            .some((e) => e.name === 'Color' && e.value === color.value)) || {};

                        if (
                            single.length > 0
                            && angular.isDefined(single[0].primaryImage)
                            && angular.isDefined(single[0].primaryImage.url)
                        ) {
                            color.imgSrc = single[0].primaryImage.url;
                            color.imgSrcThumbnail = single[0].primaryImage.url.replace(/.jpg/, '_168x168.jpg');
                        }

                        return color;
                    });
                }
            }

            function getFlatternDistinctPropertiesMap(variations) {
                const retVal = {};

                _.each(variations, function (variation) {
                    const propertyMap = getVariationPropertyMap(variation, ['Color', 'Size']);
                    // merge
                    _.each(_.keys(propertyMap), function (x) {
                        retVal[x] = _.filter(
                            _.uniq(_.union(retVal[x], propertyMap[x]), 'value'), // pick unique "value"
                            (e) => angular.isDefined(e.value),
                        ); // get only defined values
                    });
                });

                _.each(_.keys(retVal), function (key) {
                    if (angular.isArray(retVal[key]) && retVal[key].length === 0) {
                        delete retVal[key];
                    }
                });

                retVal.keys = _.keys(retVal);

                if (retVal.Size) {
                    return rsSizingChartService.getSizingChart(currentProduct.id)
                        .then(function (response) {
                            const chart = _.first(response.data);

                            if (chart && chart.sizes && chart.sizes.length) {
                                retVal.Size = _.sortBy(retVal.Size, function (e) {
                                    const chartEntry = _.find(chart.sizes, function (s) {
                                        if (s && s.rainbowSize && e.value) {
                                            return s.rainbowSize.trim()
                                                .toLowerCase() === e.value.trim()
                                                .toLowerCase();
                                        }

                                        return false;
                                    });

                                    return chartEntry ? chartEntry.length : 0;
                                });
                            } else {
                                retVal.Size = _.sortBy(retVal.Size, (x) => +x.value.match(/[\d.]+\s/));
                            }

                            return retVal;
                        }, function () {
                            return retVal;
                        });
                }

                return $q(function (resolve) {
                    resolve(retVal);
                });
            }

            function getVariationPropertyMap(variation, props) {
                const propsToCompare = _.filter(variation.variationProperties, function (v) {
                    return _.contains(props, v.name);
                });

                return _.groupBy(propsToCompare, function (x) {
                    return x.displayName;
                });
            }

            function getSelectedPropsMap(variationPropsMap) {
                const retVal = {};

                _.each(variationPropsMap.keys, function (x) {
                    const property = _.find(variationPropsMap[x], function (y) {
                        return y.selected;
                    });

                    if (property) {
                        retVal[x] = [property];
                    }
                });
                return retVal;
            }

            function comparePropertyMaps(propMap1, propMap2) {
                return _.every(_.keys(propMap1), function (x) {
                    let retVal = propMap2.hasOwnProperty(x); // eslint-disable-line no-prototype-builtins

                    if (retVal) {
                        retVal = propMap1[x][0].value === propMap2[x][0].value;
                    }

                    return retVal;
                });
            }

            function findVariationBySelectedProps(variations, selectedPropMap) {
                return _.find(variations, function (x) {
                    return comparePropertyMaps(
                        getVariationPropertyMap(x, $scope.allVariationPropsMap.keys),
                        selectedPropMap,
                    );
                });
            }

            // filter Color and Size properties
            function checkAvailabilityForProperties(currentVariation) {
                if ($scope.allSizeProps && $scope.colorProps) {
                    let currentColor = '';

                    $scope.sizeProps = $scope.allSizeProps.map((sizeProp) => {
                        const color = currentVariation.variationProperties.filter((prop) => prop.name === 'Color');
                        let filteredSizes = [];
                        let allSizes = [];

                        currentColor = color[0].value;

                        if (color.length) {
                            filteredSizes = allVariations.filter((v) => v.variationProperties
                                .some((prop) => prop.value === color[0].value));

                            allSizes = filteredSizes.reduce(function (accumulator, item) {
                                const size = item.variationProperties.filter((prop) => prop.name === 'Size');

                                if (size.length) {
                                    accumulator.push(size[0].value);
                                }

                                return accumulator;
                            }, []);
                        }

                        sizeProp.isExist = allSizes.includes(sizeProp.value);

                        if (!sizeProp.isExist) {
                            return null;
                        }

                        const variation = filteredSizes.find((item) => item.variationProperties
                            .some((prop) => prop.value === sizeProp.value));

                        sizeProp.isEnabled = isVariationEnabled(variation);

                        return sizeProp;
                    })
                        .filter(Boolean);

                    if ($scope.sizeProps.every((prop) => prop.isEnabled === false)) {
                        $scope.colorProps.forEach((prop) => {
                            if (prop.value === currentColor) {
                                prop.isEnabled = false;
                            }
                        });
                    }
                }
            }

            $scope.selectProperty = function (property, event) {
                if (event) {
                    event.preventDefault();
                }

                if (!property) {
                    return;
                }

                // prevent from unselect current variation
                const current = _.find($scope.allVariationPropsMap[property.name], {
                    selected: true,
                });

                if (current && current.value === property.value) {
                    return;
                }

                // Select appropriate property and unselect previous selection
                $scope.allVariationPropsMap[property.displayName].forEach((item) => {
                    item.selected = item.value === property.value;
                });

                if (property.name === 'Color') {
                    const sizeVariations = allVariations.filter((x) => x.variationProperties
                        .some((prop) => prop.name === 'Color' && prop.value === property.value));

                    const variationWithDiscount = sizeVariations
                        .find((sizeVariation) => sizeVariation.price.discountAmount.amount > 0);

                    $scope.selectedVariation = angular.isDefined(variationWithDiscount)
                        ? variationWithDiscount
                        : sizeVariations[0];

                    const currentSizeVariation = _.find($scope.allVariationPropsMap.Size, { selected: true });

                    if (currentSizeVariation) {
                        currentSizeVariation.selected = false;
                    }

                    $scope.current.size = null;
                    $scope.current.color = _.find(
                        $scope.selectedVariation.variationProperties,
                        { name: 'Color' },
                    ).value;
                } else {
                    // try to find the best variation match for selected properties
                    const newVariation = findVariationBySelectedProps(
                        allVariations,
                        getSelectedPropsMap($scope.allVariationPropsMap),
                    );

                    $scope.selectedVariation = angular.isDefined(newVariation)
                        ? newVariation
                        : null;

                    $scope.current.size = $scope.selectedVariation
                        ? _.find($scope.selectedVariation.variationProperties, { name: 'Size' }).value
                        : null;
                }

                if ($scope.selectedVariation) {
                    checkAvailabilityForProperties($scope.selectedVariation);

                    if (
                        angular.isUndefined($scope.selectedVariation.primaryImage)
                        || !$scope.selectedVariation.primaryImage.url
                    ) {
                        $scope.selectedVariation.primaryImage = {};
                    } else {
                        $scope.currentImage = angular.extend($scope.selectedVariation.primaryImage.url, {});
                    }
                }
            };

            $scope.selectSizeProperty = function (size) {
                const prop = $scope.sizeProps.find(({ value }) => value === size);
                $scope.selectProperty(prop);
            };

            $scope.leftSideImages = function () {
                const { images = [] } = $scope.selectedVariation;

                return images.filter((image) => image.group.includes('images')).map((image) => image.url);
            };

            $scope.makeImgPreview = function (url) {
                return url.replace(/(.[\w\d_-]+)$/i, '_64x64$1');
            };

            $scope.setCurrentImage = function (url) {
                $scope.currentImage = url;
            };

            initialize();
        },
    ]);
